<template>
    <v-row justify="center">
        <v-dialog v-model="showDialog" persistent max-width="800">
            <v-card>
                <v-card-title class="headline custom-card-header">Add Task
                    <v-spacer></v-spacer>
                    <v-btn color="white" icon @click="toggle"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-combobox
                                label="Route (Optional)"
                                :items="taskRoutes"
                                v-model="routeSelected"
                                chips
                                item-text="name"
                                item-value="id"
                                hide-no-data
                                clearable
                            ></v-combobox>
                            <v-combobox
                                label="Tags"
                                :items="taskTags"
                                v-model="tagsSelected"
                                multiple
                                chips
                                item-text="name"
                                item-value="id"
                                hide-no-data
                                clearable
                            ></v-combobox>
                            <v-text-field
                                label="Task Number / Name"
                                v-model="newTask.taskNumber"
                                chips>
                            </v-text-field>
                            <v-text-field
                                label="Type"
                                v-model="newTask.taskType"
                            ></v-text-field>
                            <div class="v-input theme--light v-text-field v-text-field--is-booted">
                                <div class="v-input__control">
                                    <div class="v-input__slot">
                                        <vue-google-autocomplete
                                            id="map-add"
                                            classname="form-control"
                                            ref="address"
                                            placeholder="Address"
                                            :country="['can']"
                                            v-on:placechanged="getAddressData"
                                        ></vue-google-autocomplete>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col xs6>
                            <v-text-field
                                label="Latitude"
                                v-model="newTask.latitude"
                                chips>
                            </v-text-field>
                        </v-col>
                        <v-col xs6>
                            <v-text-field
                                label="Longitude"
                                v-model="newTask.longitude"
                                chips>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <div v-if="disabled" class="text-center">
                        Saving<br />
                        <v-progress-circular
                            indeterminate
                            color="success"
                            v-if="disabled"
                        ></v-progress-circular>
                    </div>
                    <div v-if="this.showError" class="text-center error--text mt-3 mb-5 success-message">Task name, type and address required</div>
                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn block depressed color="accent" @click="createTask" :disabled="disabled">Add</v-btn>
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    import VueGoogleAutocomplete from 'vue-google-autocomplete'
    export default {
        created() {
            this.getTaskNumbers()
            this.getRoutes()
            this.getTags()
        },
        components: {
            VueGoogleAutocomplete
        },
        props: {
            showDialog: {
                type: Boolean,
                required: true
            },
            toggle: {
                type: Function,
                required: true
            }
        },
        data () {
            return {
                newTask: {
                    taskNumber: null,
                    address: null,
                    taskType: null,
                    routeId: null,
                    latitude: null,
                    longitude: null,
                    status: null,
                    tagIds: []
                },
                disabled: false,
                showError: false,
                routeSelected: null,
                tagsSelected: []
            }
        },
        methods: {
            ...mapActions({
                createJobTask: 'jobTasks/create',
                createRoute: 'routes/create',
                createTag:  'tags/create',
                getTaskNumbers: 'jobTasks/getTaskNumbers',
                getRouteNumbers: 'routes/getRouteNumbers',
                getRouteLocations: 'routes/getRouteAndLocations',
                getRoutes: 'routes/getAll',
                getTags: 'tags/getAll'
            }),
            async createTask () {
                if(this.newTask.taskNumber === null || this.newTask.taskType === null || this.newTask.address == null){
                    this.showError = true
                    return
                } else {
                    this.showError = false
                }
                this.disabled = true

                //Handle assigning a new route
                if (typeof this.routeSelected === 'string') { //if it is a string then it is a new route that does not already exist
                    const data = {
                        name: this.routeSelected
                    }
                    this.newTask.routeId = await this.createRoute(data)
                    this.newTask.status = 'Assigned'
                } else if (this.routeSelected !== null && typeof this.routeSelected !== 'string' && this.routeSelected !== undefined) {
                    this.newTask.routeId = this.routeSelected.id //otherwise its an existing route object with an existing routeId
                    this.newTask.status = 'Assigned'
                } else {
                    this.newTask.routeId = this.routeSelected //null or undefined
                    this.newTask.status = 'Unassigned'
                }

                //Handle assigning tags - similar but in a loop
                if(!Array.isArray(this.tagsSelected)){
                    this.tagsSelected = [this.tagsSelected]
                }
                for(const tagIdx in this.tagsSelected){
                    const tag = this.tagsSelected[tagIdx]
                    if (typeof tag === 'string') {
                        const data = {
                            name: tag
                        }
                        this.newTask.tagIds.push( await this.createTag(data))
                    } else if (tag !== null && typeof tag !== 'string' && tag !== undefined) { //This is an existing Attribute Object - use its id
                        this.newTask.tagIds.push(tag.id)
                    } else {
                        this.newTask.tagIds.push(tag)
                    }
                }
                await this.createJobTask(this.newTask)
                await this.getRouteLocations()
                if (!this.error) {
                    this.toggle()
                }
                this.tagsSelected = []
                this.disabled = false
            },
            getAddressData (data) {
                const field = document.querySelector('input[id=map-add]').value
                this.newTask.latitude = data.latitude
                this.newTask.longitude = data.longitude
                this.newTask.address = field
            }
        },
        computed: {
            ...mapGetters({
                taskNumbers: 'jobTasks/jobTaskNumbers',
                routeNumbers: 'routes/routeNumbers',
                taskRoutes: 'routes/routes',
                taskTags: 'tags/tags',
                error: 'jobTasks/error'
            })
        },
        watch: {
            showDialog(){
                this.tagsSelected = []
                this.newTask.tagIds = []
                this.newTask.taskNumber = null
                this.newTask.taskType = null
                this.newTask.routeSelected = null
                this.showError = false
            },
        }
    }
</script>
<style scoped>
    .custom-card-header {
        background-color: #00A5C5;
        color: white;
    }
</style>
